// extracted by mini-css-extract-plugin
export default {"panels":"Panels_panels__nF8Ps","panels_bg":"Panels_panels_bg__GfuTz"};